export interface SSEEvent {
  type: string
  [key: string]: unknown
}

// 从 ReadableStream 解析 SSE 事件：按 \n\n 分帧，剥离 data: 前缀，JSON.parse
// 协议：data: {"type":"chunk","content":"..."} / {"type":"usage"} / {"type":"done"} / {"type":"error"}
export async function readSSE(
  stream: ReadableStream<Uint8Array>,
  onEvent: (e: SSEEvent) => void,
  signal?: AbortSignal
): Promise<void> {
  const reader = stream.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  const close = () => {
    try {
      reader.releaseLock()
    } catch {
      /* noop */
    }
  }
  try {
    while (true) {
      if (signal?.aborted) {
        await reader.cancel().catch(() => {})
        break
      }
      const { done, value } = await reader.read()
      if (done) break
      buffer += decoder.decode(value, { stream: true })

      let idx = buffer.indexOf('\n\n')
      while (idx >= 0) {
        const frame = buffer.slice(0, idx)
        buffer = buffer.slice(idx + 2)
        const line = frame.split('\n').find(l => l.startsWith('data:'))
        if (line) {
          const json = line.slice(5).trim()
          if (json) {
            try {
              const ev = JSON.parse(json) as SSEEvent
              onEvent(ev)
            } catch {
              /* skip malformed frame */
            }
          }
        }
        idx = buffer.indexOf('\n\n')
      }
    }
  } finally {
    close()
  }
}
